import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { useSelector } from "react-redux"

import { ICargoOwner } from "~/features/cargo/api/types"
import { RootState } from "~/store/store"

export interface ISelectedCargoOwner extends ICargoOwner {}

export interface CargoOwnerSelectionState {
  selectedCargoOwner?: ISelectedCargoOwner
}

export const initialCargoOwnerState: CargoOwnerSelectionState = {}

export const cargoOwnerSelectionSlice = createSlice({
  name: "cargo-owner-selection",
  initialState: initialCargoOwnerState,
  reducers: {
    setSelectedCargoOwner: (
      state,
      action: PayloadAction<ICargoOwner>,
    ) => {
      state.selectedCargoOwner = {
        ...action.payload,
      }
    },
  },
})

export const useCargoOwnerSelection = (): CargoOwnerSelectionState =>
  useSelector((state: RootState) => state.cargoOwners)

export const { setSelectedCargoOwner } = cargoOwnerSelectionSlice.actions

export default cargoOwnerSelectionSlice.reducer
